"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _airbnbPropTypes = require("airbnb-prop-types");
var _propTypes = require("prop-types");
var _propTypes2 = require("@agillic/prop-types");
var _tabPane = _interopRequireDefault(require("./tabPane/tabPane.presenter"));
var _icon = _interopRequireDefault(require("../icon/icon.presenter"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var findSelectedTabPane = function findSelectedTabPane(_ref) {
  var tabs = _ref.children,
    selectedTab = _ref.selectedTab;
  return tabs.find(function (_ref2) {
    var tab = _ref2.props.tab;
    return tab === selectedTab;
  }).props;
};
var NavigationTabs = function NavigationTabs(_ref3) {
  var children = _ref3.children,
    selectedTab = _ref3.selectedTab,
    onSelectTab = _ref3.onSelectTab,
    backgroundColor = _ref3.backgroundColor,
    indicatorColor = _ref3.indicatorColor,
    iconPosition = _ref3.iconPosition,
    uniqueID = _ref3.uniqueID;
  var _findSelectedTabPane = findSelectedTabPane({
      children: children,
      selectedTab: selectedTab
    }),
    selectedTabPane = _findSelectedTabPane.children,
    selectedTabPaneUniqueID = _findSelectedTabPane.uniqueID;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('agillicNavigationTabs'),
    "data-testid": uniqueID
  }, _react.default.createElement("div", {
    className: (0, _classnames.default)('labelsWrapper')
  }, children.map(function (_ref4) {
    var _ref4$props = _ref4.props,
      tab = _ref4$props.tab,
      label = _ref4$props.label,
      icon = _ref4$props.icon,
      disabled = _ref4$props.disabled;
    return (/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */
      _react.default.createElement("div", {
        key: tab,
        className: (0, _classnames.default)('oneTab', iconPosition, backgroundColor, "indicator--".concat(indicatorColor), {
          selected: selectedTab === tab,
          disabled: disabled
        }),
        onClick: function onClick() {
          return !disabled && onSelectTab(tab);
        }
      }, _react.default.createElement(_icon.default, {
        name: icon
      }), _react.default.createElement("span", null, label))
    );
  })), _react.default.createElement(_tabPane.default, {
    uniqueID: selectedTabPaneUniqueID
  }, selectedTabPane));
};
NavigationTabs.TabPane = _tabPane.default;
NavigationTabs.propTypes = {
  children: (0, _airbnbPropTypes.and)([_propTypes.node.isRequired, (0, _airbnbPropTypes.componentWithName)('TabPane'), (0, _propTypes2.componentWithProps)({
    propTypes: {
      tab: _propTypes.string,
      label: _propTypes.string,
      icon: _propTypes.string,
      disabled: _propTypes.bool
    },
    checkPropTypes: _propTypes.checkPropTypes
  })]),
  selectedTab: _propTypes.string,
  onSelectTab: _propTypes.func.isRequired,
  backgroundColor: (0, _propTypes.oneOf)(['grey', 'red', 'green', 'lightGreen', 'blue', 'orange', 'darkOrange', 'purple', 'yellow']).isRequired,
  indicatorColor: (0, _propTypes.oneOf)(['grey', 'red', 'green', 'lightGreen', 'blue', 'orange', 'darkOrange', 'purple', 'yellow']).isRequired,
  iconPosition: (0, _propTypes.oneOf)(['left', 'right', 'center']).isRequired,
  uniqueID: _propTypes.string.isRequired
};
NavigationTabs.defaultProps = {
  backgroundColor: 'grey',
  indicatorColor: 'orange',
  iconPosition: 'left'
};
var _default = NavigationTabs;
exports.default = _default;